import React from "react";
import "../AddFeatures/AddFeatures.scss";
import Grid from "@mui/material/Unstable_Grid2";
import { Button, Link, TextareaAutosize, Typography } from "@mui/material";
import SlidingPanel from "react-sliding-side-panel";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
  table_data: Array<{
    id: Number;
    sr_no?: Number;
    category_name?: string;
    feature_name?: string;
    field_type?: string;
    value_type?: string;
    description: string;
    action_btns: string;
    deleteable: boolean;
  }>;
}

const EditExclusions: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
  table_data,
}) => {
  const [pageStatus, setPageStatus] = React.useState<number>(1);

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  return (
    <>
      <SlidingPanel
        type={"right"}
        isOpen={open_status}
        size={75}
        panelClassName="slidingPanel"
        backdropClicked={() => value_update(attrName, false)}
      >
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={12}>
              <h4 className="mb-0">Edit Exclusions</h4>
            </Grid>
            <Grid xs={12}>
              <hr />
            </Grid>
          </Grid>
          <div className="scrollable_area">
            {pageStatus !== 2 ? (
              <Grid container spacing={3}>
                <Grid xs={12}>
                  <TextareaAutosize
                    className="text_area"
                    aria-label="empty textarea"
                    placeholder="Description"
                  />
                </Grid>
              </Grid>
            ) : null}
            {pageStatus === 2 ? (
              <Grid
                container
                spacing={2}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <Grid xs={12}>
                  <svg
                    className="checkmark"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                  >
                    <circle
                      className="checkmark__circle"
                      cx="26"
                      cy="26"
                      r="25"
                      fill="none"
                    />
                    <path
                      className="checkmark__check"
                      fill="none"
                      d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    />
                  </svg>
                  <p className="quote_success text-center">
                    Exclusion has been Edit successfully!
                  </p>
                </Grid>
              </Grid>
            ) : null}
          </div>
          {pageStatus !== 2 ? (
            <Grid container spacing={3}>
              <Grid xs={12} className="ctaBtn mt-4 text-center">
                <Button
                  variant="contained"
                  className="submitBtn fixedbtn"
                  onClick={() => {
                    setPageStatus(pageStatus + 1);
                  }}
                >
                  Done
                </Button>
              </Grid>
            </Grid>
          ) : null}
        </div>
      </SlidingPanel>
    </>
  );
};

export default EditExclusions;
